import { createContext, useReducer } from 'react';


const UserContext = createContext({
    username: null,
    email: null,
    bollywood: 1,
    hollywood: 1,
    score: 0,

    setUser: (user) => { },
    getUserRecord: () => { },
    updateScore: (score, movieCategory) => { }
});


const defaultUserReducerState = {
    username: null,
    email: null,
    bollywood: 1,
    hollywood: 1,
    score: 0,
}

const userReducer = (state, action) => {
    if (action.type === 'SET/UPDATE-USER') {
        let userRecord = state;
        userRecord.username = action.userDetails.username;
        userRecord.email = action.userDetails.email;
        return { ...userRecord };
    }
    if (action.type === 'SET/UPDATE-SCORE') {
        let userRecord = state;
        userRecord.bollywood = action.scoreDetails.bollywood ? action.scoreDetails.bollywood : state.bollywood;
        userRecord.hollywood = action.scoreDetails.hollywood ? action.scoreDetails.hollywood : state.hollywood;;
        userRecord.score = action.scoreDetails.score;
        return { ...userRecord };
    }
    if (action.type === 'GET-USER-RECORD') {
        return { ...state };
    }
    //return defaultUserReducerState;
    return state;
}

export function UserContextProvider(props) {
    // REDUCER
    const [userState, dispatchAction] = useReducer(userReducer, defaultUserReducerState);

    // CONTEXT OPRATIONS
    async function setUserHandler(user) {
        dispatchAction({ type: 'SET/UPDATE-USER', userDetails: user });

        const docId = user.email.replace(/[^\w\s]/gi, '');
        if (!docId) return;
        const url = `https://movie-trivia-hijack-default-rtdb.firebaseio.com/users/${docId}.json`;

        let scoreRecord = {
            bollywood: 1,
            hollywood: 1,
            score: 0,
        };

        const response = await fetch(url);
        if (response.ok) {
            const userRecord = await response.json();
            if (userRecord) {
                scoreRecord = {
                    bollywood: (userRecord.bollywood) ? +userRecord.bollywood : userState.bollywood,
                    hollywood: (userRecord.hollywood) ? +userRecord.hollywood : userState.hollywood,
                    score: (userRecord.score) ? +userRecord.score : userState.score
                };
            }
        }
        dispatchAction({ type: 'SET/UPDATE-SCORE', scoreDetails: scoreRecord });
    }

    const updateScoreHandler = async (score, movieCategory) => {
        try {
            if (!score || !movieCategory || !userState.username || !userState.email) return;

            const scoreRecord = {
                bollywood: (movieCategory === 'Bollywood') ? userState.bollywood + 1 : null,
                hollywood: (movieCategory === 'Hollywood') ? userState.hollywood + 1 : null,
                score: userState.score + score
            };
            dispatchAction({ type: 'SET/UPDATE-SCORE', scoreDetails: scoreRecord });

            const docId = userState.email.replace(/[^\w\s]/gi, '');
            if (!docId) return;
            const url = `https://movie-trivia-hijack-default-rtdb.firebaseio.com/users/${docId}.json`;

            // const userRecord = {
            //     username: userState.username,
            //     email: userState.email,
            //     bollywood: userState.bollywood,
            //     hollywood: userState.hollywood,
            //     score: userState.score
            // };

            await fetch(url, {
                method: 'PUT',
                body: JSON.stringify(userState)
            });
        } catch (error) {
            console.log(error);
        }
    }

    const getUserRecordHandler = () => {
        return dispatchAction({ type: 'GET-USER-RECORD' });
    }

    // CONTEXT VALUE
    const context = {
        username: userState.username,
        email: userState.email,
        bollywood: userState.bollywood,
        hollywood: userState.hollywood,
        score: userState.score,

        setUser: setUserHandler,
        getUserRecord: getUserRecordHandler,
        updateScore: updateScoreHandler
    }

    return (
        <UserContext.Provider value={context}>
            {props.children}
        </UserContext.Provider>
    )
}

export default UserContext;
